import React from "react"
import FAQ from "../../organisms/faq-section"
import styled from "styled-components"

const highlightText = styled.span`
  color: var(--burnt-orange);
  font-weight: 500;
`

const FAQItems = [
  {
    title: "How does indoor positioning work?",
    text: (
      <>
        IPS technology detects the precise location of a user's device. This can
        be accomplished using "on-device" systems accessed directly through your
        mobile device, or paired with sensors installed throughout an indoor
        space. The combination of these two techniques is called "Sensor Fusion"
        and tends to be the most accurate approach to indoor positioning today.
      </>
    ),
  },
  {
    title: "What are indoor positioning analytics?",
    text: "Indoor positioning analytics can highlight real-time events within a space for a variety of purposes. For example, tracking important assets such as documents, building material, equipment, employees, etc. can be used to increase efficiencies. Indoor positioning analytics can also highlight how people move around your indoor space and expose ways that your business can optimize its space.",
  },
  {
    title: "How do you build an indoor positioning system?",
    text: (
      <>
        <span>
          When deciding on the indoor positioning provider that will work best
          for your business, there are four key factors to evaluate:
        </span>
        <ul>
          <li>
            <span style={{ color: "#BF4320", fontWeight: "500" }}>
              Accuracy Expectations:
            </span>{" "}
            What is the realistic expectation under normal or sub-optimal
            conditions? For reference, the accuracy of assisted GPS is
            approximately three meters outdoors.
          </li>
          <li>
            <span style={{ color: "#BF4320", fontWeight: "500" }}>Budget:</span>
            How much will it cost to implement, own, and maintain? For example,
            your implementation and ownership costs may be low, but the system
            might require a lot of maintenance at an additional cost.
          </li>
          <li>
            <span style={{ color: "#BF4320", fontWeight: "500" }}>
              Response time:
            </span>
            How long does it take for the system to respond? For example,
            on-device calculations are faster than server-side ones, because of
            the latency involved for the signal to travel there and back.
          </li>
          <li>
            <span style={{ color: "#BF4320", fontWeight: "500" }}>
              Reliability:
            </span>
            How well will the solution function indoors? New systems sometimes
            get a pass when they start out buggy, but navigation is often
            mission-critical.
          </li>
        </ul>
        <span>
          Outlining your goals for each of these will enable you to build the
          appropriate indoor positioning system with the right provider.
        </span>
      </>
    ),
  },
  {
    title: "What is indoor location technology?",
    text: "Indoor location technology enables indoor positioning systems through a network of devices used to locate people or objects where GPS and other satellite technologies fail. It is important to also consider indoor mapping as part of indoor location technology since it is a key component to visualizing indoor positioning data.",
  },
  {
    title: "How accurate is WiFi positioning?",
    text: "The accuracy of WiFi positioning can vary based on many factors however, most businesses are aiming for ~4M of accuracy. This is doable depending on your WiFi configuration. Venues with Wi-Fi that have many access points and consider the location of these access points (taking room size, open space, etc. into consideration), and consistent signal strength gives an IPS the best chance for ~4M of accuracy. A venue’s commitment to strong network infrastructure is the foundation of an accurate Blue Dot position.",
  },
  {
    title: "How accurate is GPS indoors?",
    text: "The accuracy of GPS indoors will vary and depend on building size, layout, levels, and material. Although traditional GPS may work in some indoor instances, this technology was not intended to penetrate indoor spaces. It is best to work with an indoor mapping or positioning provider who can supplement these challenges.",
  },
  {
    title:
      "What is the difference between infrastructure-free and hardware positioning systems?",
    text: (
      <>
        <span>
          A large variety of techniques and devices are used to provide indoor
          positioning ranging from reconfigured devices already deployed such as
          mobile devices, WiFi, and Bluetooth; to purpose-built installations
          with beacons that are strategically placed throughout an indoor venue.
        </span>
        <span>
          Infrastructure-free systems rely solely on a user's mobile device and
          the WiFi within a venue and can equate to a low setup and maintenance
          cost. Positioning systems that utilize hardware such as beacons can be
          implemented to supplement infrastructure-free solutions but can come
          with a large price tag both to set up and maintain over time.
        </span>
      </>
    ),
  },
  {
    title:
      "How much does an infrastructure-free indoor positioning system cost?",
    text: "Apple's infrastructure-free indoor positioning system is free! The only cost that should be considered is the mapping visualization layer underneath that positioning system and the time to implement it. Contact us today to find out more about these specific costs and timelines.",
  },
]

export default function IndoorPositioningFAQ() {
  return <FAQ title="Indoor Positioning System FAQs" items={FAQItems} />
}
